import axios from "axios";
import { DataAPi, Valuasi, EndPoint } from "../components/variable/dataVariable";

const serviceAuth = {
      tokenB2B: JSON.parse(localStorage.getItem("token")),
      signature: JSON.parse(localStorage.getItem("serviceSignature"))
    }
const bodyData = {}
const bodyToken = {
                  "grantType": "client_credentials",
                  "additionalInfo": {}
                }
const bodyService = {
  "partnerServiceId": "  088899",
  "customerNo": 12345678901234567890,
  "virtualAccountNo": "  08889912345678901234567890",
  "inquiryRequestId": "abcdef-123456-abcdef",
  "paymentRequestId": "abcdef-123456-abcdef",
  "partnerReferenceNo": "abcdef-123456-abcdef",
  "trxDateTime": "2020-12-21T14:56:11+07:00",
  "paymentStatus": "Success",
  "paymentFlagReason": {
    "english": "Success",
    "indonesia": "Sukses"
  },
  "additionalInfo": {}
};

class VAService {
  signatureAuth(timeNow) {
    return axios
      .post(DataAPi.urlApiSignatureAuth, bodyData, {
        headers: {
                    "X-TIMESTAMP": timeNow,
                    "X-CLIENT-KEY": Valuasi.clientId,
                    "Private_Key": Valuasi.privatKey,
                }
      })
      .then(response => {
        if (response.data.signature) {
          localStorage.setItem("signature", JSON.stringify(response.data.signature));
        }

        return response.data;
      });
  }

  accessToken(timeNow, signature) {
    return axios
    .post(DataAPi.urlApiGetTokenb2b, bodyToken, {
      headers: {
                    'Content-Type': 'application/json',
                    'X-TIMESTAMP': timeNow,
                    'X-CLIENT-KEY': Valuasi.clientId,
                    'X-SIGNATURE': signature
                }
    })
    .then(response => {
      if (response.data.accessToken) {
        localStorage.setItem("token", JSON.stringify(response.data))
      }

      return response.data;
    })
  }

  signatureService(token, timeNow, EndURL, body, method) {
    return axios
    .post(DataAPi.urlApiSignatureService, bodyService, {
      headers: {
                    'X-TIMESTAMP': timeNow,
                    'X-CLIENT-SECRET': Valuasi.clientSecret,
                    'HttpMethod': method,
                    'EndpoinUrl': EndURL,
                    'AccessToken': token,
                },
                body: body
    })
    .then(response => {
      return response.data;
    })
  }

  servicesVA(timeNow, endPoint, auth, body){

    return axios
    .post(DataAPi.urlApiAspi + endPoint, body, {
      headers: {
                    'Content-Type': 'application/json',
                    'Authorization': serviceAuth.tokenB2B.tokenType + " " + serviceAuth.tokenB2B.accessToken,
                    'X-TIMESTAMP': timeNow,
                    'X-SIGNATURE': auth,
                    //'X-PARTNER-ID': Valuasi.clientId,
                    //'X-EXTERNAL-ID': '41807553358950093184162180797837',
                    //'CHANEL-ID': '95221',
                },
                body: body
    })

  }

}

export default new VAService();